<template>
  <div class="container">
    <div class="left">
      <span>{{info.title}}</span>
      <span  v-html="info.left"></span>
    </div>
    <div class="right">{{info.right}}</div>
  </div>
</template>

<script>
export default { 
  name: 'InfoItem',
  props: ['info'],
  data() {
    return {
      
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  .container {
    font-family: Arial;
    display: flex;
    width: 100%;
    font-size: 12px;
    line-height: 16px;
    justify-content: space-between;
    .left {
      
    }
    .right {
      text-align: right;
    }
  }
</style>